import { Appl } from "../../core/Appl";
import DashboardViewModel from "./dashboard/DashboardViewModel";

export default class CommonModule {
    public static init(): void {
        Appl.Services.add('DashboardViewModel', DashboardViewModel);
    }
}
